// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__ZeQrM","col":"styles_col___XzMm"};